import type { IServerSideDatasource } from "ag-grid-community";

import toast from "lib/toast";

import { fetchRows } from "./api";

// AG Grid SSRM fields (startRow, endRow, sortModel, …) are forwarded as-is in their native
// camelCase format — the backend's ag_request.py parses this AG Grid envelope directly.
// data_scope is our own addition and follows the platform snake_case convention.
export function createDatasource(
  datasetId: string,
  roleSlug: string,
  scope: string,
): IServerSideDatasource {
  return {
    getRows(params) {
      const {
        startRow,
        endRow,
        filterModel,
        sortModel,
        rowGroupCols,
        groupKeys,
        valueCols,
        pivotCols,
        pivotMode,
      } = params.request;
      fetchRows(
        datasetId,
        {
          startRow,
          endRow,
          filterModel,
          sortModel,
          rowGroupCols,
          groupKeys,
          valueCols,
          pivotCols,
          pivotMode,
          data_scope: scope,
        },
        roleSlug,
      )
        .then(({ row_data, row_count }) =>
          // Map back to AG Grid's expected rowData / rowCount shape
          params.success({ rowData: row_data, rowCount: row_count }),
        )
        .catch(() => {
          toast.error("Failed to load rows.");
          params.fail();
        });
    },
  };
}
